import { createContext } from 'react';

export type MegaMenuContextValue = [
  string | null,
  (id: string) => void,
  () => void,
];

export const MegaMenuContext = createContext<MegaMenuContextValue | null>(null);
